module.exports = __webpack_public_path__ + "img/1791992461621.f7469986.png";